/**
 * The hospital a platform admin is acting on in the lab pages. Kept in
 * sessionStorage (per tab) and sent as `?hospital=` on lab requests.
 * Separate from the API module so hooks can read it without loading axios.
 */
export const LAB_HOSPITAL_KEY = 'pymedic.lab.hospital';

export const getLabHospital = () => {
  try {
    return sessionStorage.getItem(LAB_HOSPITAL_KEY) || null;
  } catch {
    return null;
  }
};

export const setLabHospital = (hospitalId) => {
  try {
    if (hospitalId) sessionStorage.setItem(LAB_HOSPITAL_KEY, hospitalId);
    else sessionStorage.removeItem(LAB_HOSPITAL_KEY);
  } catch {
    // Storage blocked: the admin picks the hospital again next time.
  }
};
